export enum AuditType {
  FiveS,
  Ehs,
  Qmm,
  Es,
  Chemical
}
